export const iconFontAwesomeDesignDropletSlash = (
	<i className="fa-solid fa-droplet-slash"></i>
);
